import { render, staticRenderFns } from "./BuildingsApartmentsInhabitantsLists.vue?vue&type=template&id=e2cecba2&scoped=true&"
import script from "./BuildingsApartmentsInhabitantsLists.vue?vue&type=script&lang=js&"
export * from "./BuildingsApartmentsInhabitantsLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cecba2",
  null
  
)

export default component.exports